namespace RioERP.Membership {
    export interface SignUpRequest extends Serenity.ServiceRequest {
        DisplayName?: string;
        Email?: string;
        Mobile?: string;
        Password?: string;
    }
}
